import { Component, OnInit } from '@angular/core';
import { RouterModule,Router } from '@angular/router';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';
import { configModel } from 'src/models/config.model';
import { ConfigService } from 'src/services/config.service';

@Component({
  selector: 'app-lsr-participant-footer',
  templateUrl: './participant-footer.component.html',
  styleUrls: ['./participant-footer.component.css'],
  standalone: true,
  imports: [RouterModule,...SHARED_IMPORTS]
})
export class ParticipantFooterComponent implements OnInit {
  configModel: configModel;  
  isPrivacyPolicyFormPage: boolean;
  isUnauthorizedUserPage: boolean = false;

  constructor(private configService: ConfigService, private router: Router) { }

  ngOnInit() { 
    this.isPrivacyPolicyFormPage = this.router.url.includes('privacypolicyform');
    this.isUnauthorizedUserPage = this.router.url.includes('unauthorized-user');
  }

  openContactUs() {
    this.configService.getContactUsUrl().subscribe(url => {
      if (url) {
        window.open(url, '_blank','noopener,noreferrer');
      }
    });
  }
}
